import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  @Input() type: string;

  public userSite: string = 'userSite';

  public currentYear: string;

  public ngOnInit(): void {
    this.currentYear = moment().tz('Europe/Berlin').format('YYYY');
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/footer/footer.component.ts